export default __webpack_public_path__ + "ca3c4170b3dd69eabeafefdb67e7a875.wav";